import clsx from 'clsx'
import {Link} from 'react-router-dom'
interface IBread {
  title: string
  path: string
  isSeparator: boolean
  isActive: boolean
}
interface IBreadcrumbJeisatNotBtns {
  title: string
  breadcrumb: IBread[]
  isBtns: false
  children: undefined
}
interface IBreadcrumbJeisatBtns {
  title: string
  breadcrumb: IBread[]
  isBtns: true
  children: React.ReactNode
}
type IBreadcrumbJeisat = IBreadcrumbJeisatBtns | IBreadcrumbJeisatNotBtns
export const BreadcrumbAlmamotors = ({
  breadcrumb,
  title,
  isBtns = false,
  children,
}: IBreadcrumbJeisat) => {
  return (
    <div className='d-flex align-items-center justify-content-between w-100 mb-8'>
      <div
        id='kt_page_title'
        data-kt-swapper='true'
        data-kt-swapper-mode='prepend'
        data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
        className={clsx(
          'page-title d-flex flex-wrap me-3 flex-column'
          /* {
            'flex-column justify-content-center': appPageTitleDirection === 'column',
            'align-items-center': appPageTitleDirection !== 'column',
          } */
        )}
      >
        {/* begin::Title */}

        <h1
          className={clsx(
            'page-heading d-flex text-dark fw-bold fs-3 my-0 flex-column justify-content-center'
          )}
        >
          {title}
        </h1>
        {/* end::Title */}

        <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
          {breadcrumb.map((item, index) => (
            <li
              className={clsx('breadcrumb-item', {
                'text-dark': !item.isSeparator && item.isActive,
                'text-muted': !item.isSeparator && !item.isActive,
              })}
              key={`${item.path}${index}`}
            >
              {!item.isSeparator ? (
                <Link className='text-muted text-hover-primary' to={item.path}>
                  {item.title}
                </Link>
              ) : (
                <span className='bullet bg-gray-400 w-5px h-2px'></span>
              )}
            </li>
          ))}
          <li className='breadcrumb-item text-dark'>{title}</li>
        </ul>
      </div>
      {isBtns && <div className='d-flex align-items-center gap-2 gap-lg-3'>{children}</div>}
    </div>
  )
}
